export const HOME_TIME_LIST = [
  "11:00",
  "14:00",
  "17:30"
];
